import {
  ref,
  watch,
  computed
} from '@vue/composition-api'
import store from '@/store'

// Notification
import {
  useToast
} from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function allFetchData() {
  // Use toast
  const toast = useToast()

  const refDataTable = ref(null)

  // Table Handlers
  const tableColumns = [{
      key: 'status',
      label: 'estado',
      sortable: true
    },
    {
      key: 'createdAt',
      label: 'activación',
      sortable: true
    },
    {
      key: 'alert',
      label: 'alerta',
      sortable: true
    },
    {
      key: 'valueAlert',
      label: 'valor',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'device',
      label: 'dispositivo',
      sortable: true
    },
    {
      key: 'site',
      label: 'ubicación',
      sortable: true
    },
    {
      key: 'actions',
      label: 'acciones',
      align: 'center',
      sortable: false,
      class: 'no-sort'
    },
  ]
  const perPage = ref(10)
  const totalData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('active')
  const typeFilter = ref('all')
  const loading = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDataTable.value ? refDataTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refDataTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter, typeFilter], () => {
    refetchData()
  })

  const msgError = () => {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Error al procesar los datos',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })
  }

  const msgSuccess = () => {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Operación realizada con éxito',
        icon: 'CheckIcon',
        variant: 'success',
      },
    })
  }

  const fetchData = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertHistory/fetchAlerts', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
        typeAlert: typeFilter.value === 'users' ? '' : typeFilter.value, // Handle "other" option
      })
      .then(response => {
        const {
          rows,
          count
        } = response.data

        // Filter rows if typeFilter is "other"
        let filteredRows = rows;
        if (typeFilter.value === 'users') {
          filteredRows = rows.filter(item => item.typeAlert !== 'status');
        }

        callback(filteredRows)
        totalData.value = count
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchUpdate = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertHistory/deactivateAlert', {
        id: ctx
      })
      .then(response => {
        const alert = response.data
        const index = refDataTable.value.localItems.findIndex(item => item.id === alert.id)
        refDataTable.value.localItems.splice(index, 1)
        msgSuccess()
        loading.value = false
        callback(alert)
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchExport = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertHistory/exportAlert', {
        q: searchQuery.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
        typeAlert: typeFilter.value,
      })
      .then(response => {
        msgSuccess()
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchCountAlertActive = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertHistory/countAlertActive', {
        ctx
      })
      .then(response => {
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }
  const fetchCountAlertActiveBySite = (ctx, callback) => {
    const siteId = ctx
    loading.value = true
    store
      .dispatch('alertHistory/countAlertActiveBySite', {
        ctx
      }, siteId)
      .then(response => {
        //callback(response.data)
        loading.value = false
        return response.data
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchAlertsByDevice = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertHistory/fetchAlertsByDevice', {
        id: ctx.deviceId,
        dataKey: ctx.dataKey,
      })
      .then(response => {
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  return {
    fetchData,
    fetchUpdate,
    fetchExport,
    fetchCountAlertActive,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataTable,
    loading,
    statusFilter,
    typeFilter,
    refetchData,
    fetchCountAlertActiveBySite,
    fetchAlertsByDevice,
  }
}